module.exports = __webpack_public_path__ + "static/juvencard@2x.30acd625.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvencard@2x.png
// module id = 725
// module chunks = 92562407457355